import axios from 'axios'

const $http = axios.create({
  baseURL: '/na-api',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  }
})

$http.interceptors.response.use(({ data }) => data, ({ response }) => {
  let res = {}
  const { data = {}, status } = response

  if (typeof data !== 'object') {
    res.message = data
  } else {
    res = data
  }

  if (!res.code) {
    res.code = status
  }
  return Promise.reject(res)
})

export default $http
